import React from 'react'
import { Radio } from 'lucide-react'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { cn } from '@/lib/utils'

/** Aviso temporal de pre-lanzamiento (poner en `false` para ocultar). */
export const SHOW_PRELAUNCH_NOTICE = false

export function HomePrelaunchNotice() {
  const t = useTranslation()

  if (!SHOW_PRELAUNCH_NOTICE) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'browse-prelaunch-notice mobile-app__info-panel space-y-3 px-6 py-6 text-center sm:px-8',
        'animate-[prelaunch-pulse_3.2s_ease-in-out_infinite]',
      )}
    >
      <p className="mobile-app__info-kicker inline-flex items-center justify-center gap-1.5 text-amber-200">
        <Radio className="size-3.5" aria-hidden />
        {t.homeDashboard.prelaunch.kicker}
      </p>
      <h2 className="font-mono text-lg font-semibold uppercase tracking-wider text-amber-200 sm:text-xl">
        {t.homeDashboard.prelaunch.headline}
      </h2>
      <p className="mx-auto max-w-2xl mobile-app__body-text text-muted-foreground">
        {t.homeDashboard.prelaunch.lead}
      </p>
    </div>
  )
}
